import { render, staticRenderFns } from "./SchoolNewsCard.vue?vue&type=template&id=64f85a9c&scoped=true"
import script from "./SchoolNewsCard.vue?vue&type=script&lang=js"
export * from "./SchoolNewsCard.vue?vue&type=script&lang=js"
import style0 from "./SchoolNewsCard.vue?vue&type=style&index=0&id=64f85a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f85a9c",
  null
  
)

export default component.exports